import axios from 'axios';

export default axios.create({
    baseURL: 'https://api.unsplash.com',
    headers: {
        Authorization: 'Client-ID qST5zGB7sHw9WrelgTew6Mr8rfl1ungS_M-mLBi0H5Q'
    }

});